import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription, lastValueFrom } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UserInfo } from '../../../../models/user-info.model';
import {
  GraphService,
  SharemailboxStatus,
} from 'src/app/services/graph/graph.service';
import { SharemailboxListFields } from '../../../../models/sharemailbox-list-fields.model';
import { UsersService } from 'src/app/services/users/users.service';
import { MatDialog } from '@angular/material/dialog';
import { entAnimations } from 'src/app/animations';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { Error } from 'src/app/models/error.model';
import { LocalStorageService } from 'src/app/services/localStorage/localStorage.service';
import { SettingsService } from 'src/app/services/settings/settings.service';
import { AddUserDialogComponent } from '../../adduser-dialog/adduser-dialog.component';

@Component({
  selector: 'app-sharemailbox-detail',
  templateUrl: './sharemailbox-detail.component.html',
  styleUrls: ['./sharemailbox-detail.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: entAnimations,
  standalone: false,
})
export class SharemailboxDetailComponent implements OnInit, OnDestroy {
  // Route Parameters Subscription
  private subscription: Subscription = new Subscription();

  sharemailboxid: string;
  isLoading = false;

  isErrorUpdateSharemailbox = false;
  isErrorGetSharemailbox = false;

  isBusy = false;

  isBusyUpdateSharemailbox = false;
  error: Error = { error: { message: '', code: '' } };
  errorUpdateSharemailbox: Error = { error: { message: '', code: '' } };
  errorGetSharemailbox: Error = { error: { message: '', code: '' } };

  selectedShairemailbox: SharemailboxListFields;

  spinner = {
    color: 'primary',
    mode: 'indeterminate' as ProgressSpinnerMode,
    value: 50,
    diameter: 50,
  };

  // Pwd
  sharemailboxform: FormGroup;
  issharemailboxUpdated = false;

  // Form to Bolean
  displayInGal = false;
  ajout_Directeur = false;
  ajout_ConseilDir = false;
  ajout_secDir = false;
  ajout_admin = false;
  ajout_Tech = false;
  ajout_ITRes = false;
  ajout_ITGest = false;
  ajout_PersonEns = false;

  sendas_Directeur = false;
  sendas_ConseilDir = false;
  sendas_secDir = false;
  sendas_admin = false;
  sendas_Tech = false;
  sendas_ITRes = false;
  sendas_ITGest = false;

  users: UserInfo[] = [];
  private filteredusers: UserInfo[];

  sendAs_Nom: UserInfo[] = [];

  isLoadingUsers = false;
  allmyusers: UserInfo[];

  isDisabled = false;
  entAccessEdit = false;
  hasError = false;

  /**
   * Constructor
   */
  constructor(
    private _graphService: GraphService,
    private _activatedRoute: ActivatedRoute,
    private _formBuilder: FormBuilder,
    private _router: Router,
    private _userService: UsersService,
    private _matDialog: MatDialog,
    private _localStorageService: LocalStorageService,
    private _settingsService: SettingsService
  ) {}

  ngOnInit() {
    const geSubscription = this._settingsService.currentGE$.subscribe(() => {
      this._router.navigate(['/exchange/sharemailbox']);
    });
    this.subscription.add(geSubscription);

    this.isLoading = false;
    this.isBusy = false;

    const activatedRouteSubcription = this._activatedRoute.params.subscribe(
      params => {
        this.sharemailboxid = params['id'];

        if (this.sharemailboxid == null) {
          this._router.navigate(['/exchange/sharemailbox']);
        }
      }
    );
    this.subscription.add(activatedRouteSubcription);

    this.getSharemailboxbyID();

    this.sharemailboxform = this._formBuilder.group({
      displayName: [''],
    });
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscription.unsubscribe();
  }

  addUserForAccess(): void {
    this.filteredusers = [].concat(this.allmyusers);
    for (const user of this.users) {
      if (
        this.filteredusers.findIndex(
          e => e.officialemail === user.officialemail
        ) > 0
      ) {
        this.filteredusers.splice(
          this.filteredusers.findIndex(
            e => e.officialemail === user.officialemail
          ),
          1
        );
      }
    }

    const dialogRef = this._matDialog.open(AddUserDialogComponent, {
      data: {
        _users: this.users.map(user => user.officialemail),
        singleUser: false,
      },
      panelClass: 'add-user-dialog',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((selectedusers: UserInfo[]) => {
      for (const user of selectedusers) {
        const temp = new UserInfo();
        temp.officialemail = user.officialemail;
        this.users.push(temp);
      }
    });
  }

  addUserForSendAs(): void {
    this.filteredusers = [].concat(this.allmyusers);

    for (const user of this.sendAs_Nom) {
      if (
        this.filteredusers.findIndex(
          e => e.officialemail === user.officialemail
        ) >= 0
      ) {
        this.filteredusers.splice(
          this.filteredusers.findIndex(
            e => e.officialemail === user.officialemail
          ),
          1
        );
      }
    }

    const dialogRef = this._matDialog.open(AddUserDialogComponent, {
      data: {
        _users: this.sendAs_Nom.map(user => user.officialemail),
        singleUser: false,
      },
      panelClass: 'add-user-dialog',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(selectedusers => {
      for (const user of selectedusers) {
        const temp = new UserInfo();
        temp.officialemail = user.officialemail;
        this.sendAs_Nom.push(temp);
      }
    });
  }

  setDefaultFormValue(): void {
    // Set Default value for Step 1

    this.sharemailboxform
      .get('displayName')
      .setValue(this.selectedShairemailbox?.title ?? '');

    if (this.selectedShairemailbox.rqarFullAccessUsersOrGroups != null) {
      const nomUserList =
        this.selectedShairemailbox.rqarFullAccessUsersOrGroups.split(';');
      for (const email of nomUserList) {
        const temp = new UserInfo();
        temp.officialemail = email;
        this.users.push(temp);
      }
    }

    if (this.selectedShairemailbox.rqaSendAsUsersOrGroups != null) {
      const sendAs_NomList =
        this.selectedShairemailbox.rqaSendAsUsersOrGroups.split(';');
      for (const email of sendAs_NomList) {
        const temp = new UserInfo();
        temp.officialemail = email;
        this.sendAs_Nom.push(temp);
      }
    }

    this.displayInGal = this.validateBoolean(
      this.selectedShairemailbox.displayInGAL
    );

    this.ajout_admin = this.validateBoolean(
      this.selectedShairemailbox.rqarFullAccessGrAdministratif
    );
    this.ajout_ConseilDir = this.validateBoolean(
      this.selectedShairemailbox.rqarRFullAccessGrConseilDirection
    );
    this.ajout_Directeur = this.validateBoolean(
      this.selectedShairemailbox.rqarFullAccessGrDirecteur
    );
    this.ajout_ITGest = this.validateBoolean(
      this.selectedShairemailbox.rqarFullAccessGrITGestionnaire
    );
    this.ajout_ITRes = this.validateBoolean(
      this.selectedShairemailbox.rqarFullAccessGrITResponsable
    );
    this.ajout_secDir = this.validateBoolean(
      this.selectedShairemailbox.rqarFullAccessGrSecretaireDirect
    );
    this.ajout_Tech = this.validateBoolean(
      this.selectedShairemailbox.rqarFullAccessGrTechnique
    );

    this.sendas_admin = this.validateBoolean(
      this.selectedShairemailbox.rqarSendAsGrAdministratif
    );
    this.sendas_ConseilDir = this.validateBoolean(
      this.selectedShairemailbox.rqarSendAsGrConseilDirection
    );
    this.sendas_Directeur = this.validateBoolean(
      this.selectedShairemailbox.rqarSendAsGrDirecteur
    );
    this.sendas_ITGest = this.validateBoolean(
      this.selectedShairemailbox.rqarSendAsGrITGestionnaire
    );
    this.sendas_ITRes = this.validateBoolean(
      this.selectedShairemailbox.rqarSendAsGrITResponsable
    );
    this.sendas_secDir = this.validateBoolean(
      this.selectedShairemailbox.rqarSendAsGrSecretaireDirection
    );
    this.sendas_Tech = this.validateBoolean(
      this.selectedShairemailbox.rqarSendAsGrTechnique
    );

    this.entAccessEdit = this.validateBoolean(
      this.selectedShairemailbox.entAccessEdit
    );

    if (this.entAccessEdit) {
      this.isDisabled = false;
    } else {
      this.isDisabled = true;
      this.sharemailboxform.get('displayName').disable();
    }
  }

  private validateBoolean(input: string | null | undefined): boolean {
    return input === 'True' ? true : false;
  }

  private fetchressourceformData(): SharemailboxListFields {
    // Reset all errors and boolean in case of multiple error
    this.isBusy = false;

    const nomUserList = [];
    for (const user of this.users) {
      nomUserList.push(user.officialemail);
    }

    const sendAs_NomList = [];
    for (const user of this.sendAs_Nom) {
      sendAs_NomList.push(user.officialemail);
    }

    return {
      // Standard Config
      type: 'Sharemailbox',
      etatdelabo_x00ee_te: SharemailboxStatus.MODIFY,

      // Forms
      title: this.sharemailboxform.get('displayName').value as string,

      // Checkbox
      displayInGAL: this.firstCharToUpper(this.displayInGal),

      // Personnel technique
      rqarFullAccessGrTechnique: this.firstCharToUpper(this.ajout_Tech),
      rqarSendAsGrTechnique: this.firstCharToUpper(this.sendas_Tech),

      // Personnel administratif
      rqarFullAccessGrAdministratif: this.firstCharToUpper(this.ajout_admin),
      rqarSendAsGrAdministratif: this.firstCharToUpper(this.sendas_admin),

      // Secrétaire de direction
      rqarFullAccessGrSecretaireDirect: this.firstCharToUpper(
        this.ajout_secDir
      ),
      rqarSendAsGrSecretaireDirection: this.firstCharToUpper(
        this.sendas_secDir
      ),

      // IT-Responsable
      rqarFullAccessGrITResponsable: this.firstCharToUpper(this.ajout_ITRes),
      rqarSendAsGrITResponsable: this.firstCharToUpper(this.sendas_ITRes),

      // IT-Gestionnaire
      rqarFullAccessGrITGestionnaire: this.firstCharToUpper(this.ajout_ITGest),
      rqarSendAsGrITGestionnaire: this.firstCharToUpper(this.sendas_ITGest),

      // Directeur
      rqarFullAccessGrDirecteur: this.firstCharToUpper(this.ajout_Directeur),
      rqarSendAsGrDirecteur: this.firstCharToUpper(this.sendas_Directeur),

      // Conseil de Direction
      rqarRFullAccessGrConseilDirection: this.firstCharToUpper(
        this.ajout_ConseilDir
      ),
      rqarSendAsGrConseilDirection: this.firstCharToUpper(
        this.sendas_ConseilDir
      ),

      rqarFullAccessUsersOrGroups: nomUserList.join(';'),
      rqaSendAsUsersOrGroups: sendAs_NomList.join(';'),
    };
  }

  private firstCharToUpper(input: string | boolean): string {
    return String(input).charAt(0).toUpperCase() + String(input).slice(1);
  }

  remove(users: UserInfo): void {
    const index = this.users.indexOf(users);
    if (index >= 0) {
      this.users.splice(index, 1);
    }
    this.filteredusers = [].concat(this.allmyusers);
  }

  removeSendas(users: UserInfo): void {
    const index = this.sendAs_Nom.indexOf(users);
    if (index >= 0) {
      this.sendAs_Nom.splice(index, 1);
    }
    this.filteredusers = [].concat(this.allmyusers);
  }

  async updateSharemailbox(): Promise<void> {
    this.errorUpdateSharemailbox = { error: { message: '', code: '' } };
    this.isErrorUpdateSharemailbox = false;
    this.issharemailboxUpdated = false;
    this.isBusyUpdateSharemailbox = true;

    try {
      const updatedSharemailbox = this.fetchressourceformData();

      await lastValueFrom(
        this._graphService.updateSharemailbox(
          this.sharemailboxid,
          updatedSharemailbox
        )
      ).then(() => {
        this.issharemailboxUpdated = true;
        this.isBusyUpdateSharemailbox = false;
      });
    } catch (error) {
      let customError: Error = { error: undefined };

      if (error.statusText == 'Unknown Error') {
        customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
      } else {
        if (error.error) {
          customError = error.error;
        }
        if (customError.error === undefined) {
          customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
        }
      }

      this.isErrorUpdateSharemailbox = true;
      this.errorUpdateSharemailbox = customError;
      this.issharemailboxUpdated = false;
      this.isBusyUpdateSharemailbox = false;
    }
  }

  async getSharemailboxbyID(): Promise<void> {
    try {
      this.isLoading = true;
      this.selectedShairemailbox = await lastValueFrom(
        this._graphService.getSharemailboxById(this.sharemailboxid)
      );
      if (
        this.selectedShairemailbox.etatdelabo_x00ee_te !=
        SharemailboxStatus.UPTODATE
      ) {
        this._router.navigate(['exchange/sharemailbox']);
      }

      this.setDefaultFormValue();
      this.isErrorGetSharemailbox = false;
      this.errorGetSharemailbox = { error: { message: '', code: '' } };
    } catch (error) {
      let customError: Error = { error: undefined };

      if (error.statusText == 'Unknown Error') {
        customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
      } else {
        if (error.error) {
          customError = error.error;
        }
        if (customError.error !== undefined) {
          if (customError.error.code == 'ERR403') {
            this._router.navigate(['/errors/error-403']);
          } else {
            this._router.navigate(['/errors/error-404']);
          }
        }
      }
      this.isErrorGetSharemailbox = true;
      this.errorGetSharemailbox = customError;
    } finally {
      this.isLoading = false;
      if (!this.isDisabled) {
        this.getAllUsersEnsPAT();
      }
    }
  }

  async getAllUsersEnsPAT(): Promise<void> {
    try {
      this._localStorageService.removeItem('myusers_ens_pat');

      this.isLoadingUsers = true;
      this.hasError = false;
      this.allmyusers = await lastValueFrom(
        this._userService.getAllUsersEnsPAT(
          this.selectedShairemailbox.gE_x002d_Choix_x003a_Title
        )
      );

      const filtered = new Array<UserInfo>();

      this.allmyusers.forEach(function (user) {
        if (user.classe == '-' || user.classe == '') {
          filtered.push(user);
        }
      });

      this.allmyusers = filtered;
      this.isLoadingUsers = false;
    } catch {
      this.hasError = true;
      this.isDisabled = true;
    } finally {
      this.isLoadingUsers = false;
    }
  }
}
